/* admin_localities */
export const GET_ADMIN_LOCALITIES_REQUEST =
  'resources/admin/localities/GET_ADMIN_LOCALITIES_REQUEST'
export const GET_ADMIN_LOCALITIES_SUCCESS =
  'resources/admin/localities/GET_ADMIN_LOCALITIES_SUCCESS'
export const GET_ADMIN_LOCALITIES_ERROR =
  'resources/admin/localities/GET_ADMIN_LOCALITIES_ERROR'
